export default "__VITE_ASSET__BGuGjGCu__"